<template>
  <mf-loading-dialog :loading="$apollo.queries.flyer.loading">
    <base-page-layout title="Resultados do encarte" class="alteracao-encartes">
      <div v-if="!$apollo.queries.flyer.loading" class="result-flyer">
        <v-container class="pa-0" fluid>
          <v-card style="margin-top: 10px">
            <v-card-text>
              <div class="d-flex align-center">
                <span class="title-medium" style="margin-right: 20px">{{ flyer.title }}</span>
                <mf-icon small color="marca-0-l40">check_circle</mf-icon>
                <span class="marca-0-l40-text ml-1">{{ this.getFormatedStatus(flyer.status) }}</span>
              </div>
              <span class="description">{{ flyer.description }}</span>
              <v-row style="margin-top: 8px">
                <v-col cols="3">
                  <div class="title-medium" style="margin-bottom: 10px">Período de exibição</div>
                  <v-chip v-if="interval">{{ interval }}</v-chip>
                </v-col>
                <v-col cols="4">
                  <div class="title-medium" style="margin-bottom: 10px">Lojas de exibição</div>
                  <fichas-items :items="flyer.units" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <div class="title-medium" style="margin-bottom: 10px">Páginas</div>
                  <fichas-items :items="[{ name: flyer.images.length }]" />
                </v-col>
                <v-col v-if="flyer.original_file" cols="4">
                  <div class="title-medium" style="margin-bottom: 10px">Arquivo Original</div>
                  <span class="link" @click="goToFileUrl(flyer.original_file.url)">{{ flyer.original_file.filename }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>

        <v-divider class="divider" />

        <v-container v-if="modules.chatbot" class="pa-0" fluid>
          <div class="title-big">Resultados principais</div>
        </v-container>
        <v-container v-if="modules.mobile" class="pa-0" fluid>
          <div class="title-medium" style="margin-top: 10px 0 8px">Aplicativo</div>
          <v-row>
            <v-col v-for="(card, index) in resultadosAplicativo" :key="index" cols="4">
              <cbm-card :number-text="card.value" :title="card.text" unset-percentage-colors simple-card />
            </v-col>
          </v-row>
        </v-container>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Desativar',
            action: disableFlyer,
            isVisible: flyer.status === 'ACTIVE',
            isDisabled: false,
          }"
          :cancel-button="{
            text: 'Voltar',
            action: redirectEncartes,
            isVisible: true,
            isDisabled: false,
          }"
        />
      </div>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import FichasItems from '@/components/FichasItems.vue'
import CbmCard from '@/components/CbmCard.vue'
import { QUERY_FLYER, MUTATION_TOGGLE_FLYER } from '../../graphql'
import { localeString } from '@/config/helpers.js'
import { DateTime } from 'luxon'

export default {
  name: 'ResultadosEncarte',
  components: {
    BasePageLayout,
    FichasItems,
    CbmCard,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    modules() {
      return this.$getAllowedModules()
    },
    interval() {
      return `${this.formatDate(this.flyer.initial_date)} - ${this.formatDate(this.flyer.final_date)}`
    },
    resultadosAplicativo() {
      return [
        {
          text: 'Total de cliques',
          value: localeString(this.flyer.metrics.app.total_clicks || 0),
        },
      ]
    },
  },
  apollo: {
    flyer: {
      query: QUERY_FLYER,
      variables() {
        return {
          _id: this.$route.params.id,
        }
      },
    },
  },
  methods: {
    goToFileUrl(url) {
      window.open(url, '_blank')
    },
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('dd/MM/yyyy')
    },
    getFormatedStatus(status) {
      switch (status.toLowerCase()) {
        case 'active':
          return 'Ativo'
        case 'finished':
          return 'Concluído'
        default:
          break
      }
    },
    redirectEncartes() {
      this.$router.push('/mobile/encartes').catch(() => {})
    },
    async disableFlyer() {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_TOGGLE_FLYER,
          variables: {
            _id: this.$route.params.id,
            active: false,
          },
        })
        this.$router.push('/mobile/encartes').catch(() => {})
      } catch (error) {}
    },
  },
}
</script>

<style lang="scss" scoped>
.result-flyer {
  .marca-0-l40-text {
    color: $marca-0-l40;
  }
  .title-big {
    font-size: 36px;
    color: $cinza-d20;
    letter-spacing: 0.6px;
  }
  .title-medium {
    font-weight: bold;
    font-size: 20px;
    color: $cinza-d20;
    letter-spacing: 0.33px;
  }
  .status {
    font-size: 12px;
    letter-spacing: 0.2px;
  }
  .description {
    font-size: 14px;
    color: $cinza-d10;
    letter-spacing: 0.23px;
  }
  .divider {
    margin: 30px 0px 20px;
  }
  .info-icon {
    float: right;
    cursor: pointer;
  }
  .push-card {
    height: 150px;
    .v-card__text {
      height: 100%;
    }
    .push-card-title {
      font-size: 16px;
      letter-spacing: 0.27px;
      color: $cinza-l10;
      margin-bottom: 22px;
    }
    .push-card-value {
      font-size: 35px;
      letter-spacing: 0.58px;
      color: $cinza-d20;
    }
  }
  .push-card-dark {
    .push-card-title {
      color: $marca-0-l90;
    }
    .push-card-value {
      color: $branco;
    }
  }
}
</style>
